import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";

export interface PersonListItem {
  id_user?: string | number;
  userId?: string | number;
  user_id?: string | number;
  id?: string | number;
  name?: string;
  surname?: string;
  email?: string;
  username?: string;
}

interface UsePeopleListArgs {
  corporateId: string | number;
  roleFilter: string;
  page: number;
  pageSize: number;
  search?: string;
  enabled?: boolean;
}

export const usePeopleList = ({
  corporateId,
  roleFilter,
  page,
  pageSize,
  search,
  enabled = true,
}: UsePeopleListArgs): PaginatedListResult<PersonListItem> => {
  const url =
    enabled && corporateId
      ? `${ServicesURL.faculties}?corporate_id=${corporateId}&${roleFilter}`
      : null;

  return usePaginatedList<PersonListItem>(url, { page, pageSize, search });
};

export const getPersonId = (p: PersonListItem): string => {
  const raw = p.id_user ?? p.userId ?? p.user_id ?? p.id;
  return raw != null && raw !== "" ? String(raw) : "";
};

export const getPersonName = (p: PersonListItem): string => {
  const full = [p.name, p.surname].filter(Boolean).join(" ").trim();
  return full || p.username || p.email || "-";
};
